


























import Vue from "vue";
import SettingItem from "@/components/SettingItem.vue";
import { setLS } from "@/services";
import { StorageType } from "@/models/StorageType";

export default Vue.extend({
  components: {
    SettingItem,
  },
  computed: {
    initialMailUrl(): string {
      return this.$store.state.mailUrl || "";
    },
    initialMapUrl(): string {
      return this.$store.state.mapUrl || "";
    },
    initialNewsUrl(): string {
      return this.$store.state.newsUrl || "";
    },
  },
  methods: {
    mailChange(newUrl: string): void {
      setLS(StorageType.MAILURL, newUrl);
    },
    mapChange(newUrl: string): void {
      setLS(StorageType.MAPURL, newUrl);
    },
    newsChange(newUrl: string): void {
      setLS(StorageType.NEWSURL, newUrl);
    },
  },
});
